import { useCallback, useEffect } from 'react';

import { useGetReportPreferencesQuery, useSaveReportPreferencesQuery } from '../queries';
import { useFavoriteReportsStore } from '../stores';

const useFavoriteReportHandler = (key: string) => {
  const { handleSave, isLoading: isSaveLoading } = useSaveReportPreferencesQuery();
  const { data, isLoading } = useGetReportPreferencesQuery();
  const isFavorite = useFavoriteReportsStore((state) => state.reportKeys.includes(key));
  const toggleReportKey = useFavoriteReportsStore((state) => state.toggleReportKey);
  const reportKeys = useFavoriteReportsStore((state) => state.reportKeys);

  const setReportKeys = useFavoriteReportsStore((state) => state.setReportKeys);

  const handleToggleReportKey = useCallback(async () => {
    toggleReportKey(key);
    let newKeys = reportKeys;
    if (newKeys.includes(key)) {
      newKeys = newKeys.filter((item) => item !== key);
    } else {
      newKeys = [...newKeys, key];
    }
    await handleSave({
      ...data,
      favoriteReports: newKeys,
    });
    setReportKeys(newKeys);
  }, [data, handleSave, key, reportKeys, setReportKeys, toggleReportKey]);

  useEffect(() => {
    if (!reportKeys.length && !!data.favoriteReports.length) {
      setReportKeys(data.favoriteReports);
    }
  }, [data.favoriteReports, reportKeys.length, setReportKeys]);
  return {
    isLoading: isSaveLoading || isLoading,
    isFavorite,
    handleToggleReportKey,
  };
};

export default useFavoriteReportHandler;
